import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getRolesMenuStart,
  getRolesMenuSuccess,
  getRolesMenuFailed,
} from "../redux/roleMenu";

import { getRoleMenuApi } from "core/http/service/accountInfo";

function* getRoleMenuWork() {
  try {
    const res = yield call(getRoleMenuApi);

    yield put({
      type: getRolesMenuSuccess.type,
      payload: res?.codes,
    });
  } catch (error: any) {
    yield put({
      type: getRolesMenuFailed.type,
    });
  }
}

function* watchGetRoleMenu() {
  yield takeLatest(getRolesMenuStart.type, getRoleMenuWork);
}

export default function* getRoleMenuSaga() {
  yield all([watchGetRoleMenu()]);
}
